<link rel="preload" as="image" href="./assets/videos/standard/redesign/12xe_battery.mp4">
<link rel="preload" as="image" href="./assets/videos/standard/redesign/12xe_gaming.mp4">
<div *ngIf="!isWildcatLake">
    <ng-container *ngFor="let panel of panelData; let i = index">
        <section *ngIf="panel.panelType === ptlPanel">
            <div class="ptlpanel" *ngIf="i === 0 && panel.panelType === ptlPanel"
                style="background-image: url({{panel.detailBgUrl}});" [ngClass]="setFontIntelDisplayOne ? 'intelOne-display':''">
                <!--HERO CONTENT-->
                <div>
                    <div [ngClass]="[isPtl12Xe ? 'proc_12xe_container' : 'proc_std_container', (isPtl12Xe && rtlLangs.includes(language)) ? 'proc_12xe_container_rtlLang' :'']">
                        <div [ngClass]="isPtl12Xe ? 'ptl-panel-badge' : 'ptl-panel-badge-std'"
                            *ngIf="panel.badgeUrl || panel.badgeUrl1">
                            <img *ngIf="panel.badgeUrl" [src]="panel.badgeUrl" alt="proc_badge">
                            <div *ngIf="panel.badgeUrl && panel.badgeUrl1" class="inline_separator"></div>
                            <img *ngIf="panel.badgeUrl1" [src]="panel.badgeUrl1" alt="proc2_badge">
                        </div>
                        <div class="ptl-text-block" *ngIf="i === 0">
                            <div *ngIf="!isPtl12Xe && panel.subtitle" class="ptl_std_subtitle" [class.intelOne-display]="setFontIntelDisplayOne" 
                                [innerHTML]="panel.subtitle">
                            </div>
                            <div class="ptl_proc_title" *ngIf="isPtl12Xe" [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="panel.pretitle"></div>
                        </div>
                    </div>
                    <div class="ptl_proc_title_std" *ngIf="!isPtl12Xe" [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="panel.pretitle"></div>
                    <div class="ptl_panel_title"
                        [ngClass]="[i==0 ? 'white_color_title' : '', !isPtl12Xe ? 'ptl_panel_title_std' : '', setFontIntelDisplayOne ? 'intelOne-headline' : '', !setFontIntelDisplayOne ? 'other-lang-font-style' : '', nonItalicLangArray.includes(language) ? 'non-italic-lang-cls':'']"
                        [innerHTML]="panel.title">
                    </div>
                </div>
                <!--CARDS BLOCK-->
                <div class="ptl-card-wrapper" *ngIf="panel.titleArray">
                    <div class="ptl-card" *ngFor="let item of panel.titleArray; let i = index"
                        (click)="openTileModal(tileModal, item)">
                        <div>
                            <img [src]="item.imgUrl" alt="tile-image" class="card-bg">
                            <div class="card-content" [ngClass]="{'card-content-rtlLang' : rtlLangs.includes(language)}">
                                <div class="card-badge" [class.intelOne-display]="setFontIntelDisplayOne"> 
                                    <img [src]="item.tileBadgeUrl" alt="tile_badge">
                                    <div [ngClass]="[(item.title === 'performance' && !isPtl12Xe) ? 'dark-text' : '', (item.title === 'battery' && isPtl12Xe) ? 'dark-text' : '']"
                                        [innerHTML]="item.tr_title">
                                    </div>
                                </div>
                                <div class="card-subtitle" [class.intelOne-display]="setFontIntelDisplayOne" 
                                    [ngClass]="[(item.title === 'performance' && !isPtl12Xe) ? 'dark-text' : '', (item.title === 'battery' && isPtl12Xe) ? 'dark-text' : '', (item.title === 'graphics' && isPtl12Xe) ? 'graphics-12xe-card-subtitle-width':'', (item.title == 'battery' && !isPtl12Xe) ? 'battery-std-card-subtitle-width':'', (item.title == 'gaming' && !isPtl12Xe) ? 'gaming-std-card-subtitle-width':'',  rtlLangs.includes(language) ? 'rtlLang-card-subtitle' : '']"
                                    [innerHTML]="item.tr_subtitle">
                                </div>
                            </div>
                        </div>
                        <ng-template #tileModal let-modal>
                            <div class="modal-body">
                                <div class="tile-modal-card">
                                    <!-- VIDEO-->
                                    <div class="tile-video-wrapper">
                                        <video class="tile-video" [src]="selectedTileDetail?.bgVideoUrl" [poster]= posterPath autoplay muted loop playsinline webkit-playsinline preload="metadata" (loadeddata)="onVideoLoaded()"></video>
                                    </div>
                                    <!-- CONTENT-->
                                    <div *ngIf="videoLoaded" class="tile-modal-content"
                                       [ngClass]="[isPtl12Xe ? selectedTileTitle + '-12xe-popup-content' : selectedTileTitle + '-std-popup-content', !setFontIntelDisplayOne ? setFont() : '']">
                                        <div class="tile-modal-title" [ngClass]="{'intelOne-headline': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}" [innerHTML]="selectedTileDetail?.tr_title">
                                        </div>
                                        <div class="tile-modal-subtitle" [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="selectedTileDetail?.tr_subtitle">
                                        </div>
                                        <div class="ptl-borderddp-card" [class.intelOne-display]="setFontIntelDisplayOne" 
                                            *ngIf="selectedTileDetail?.detailsArray?.length">
                                            <ul>
                                                <li *ngFor="let item of selectedTileDetail.detailsArray"
                                                    [innerHTML]="item?.tr_title"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="videoLoaded" class="close-icon-std-12xe" (click)="closeModel()">
                                    <img src="assets/images/touchless_popup_close_button.svg" alt="close">
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </section>
    <!-- </ng-container>
</div> -->

    <!-- PTL Gaming Processor DDP start -->
    <section *ngIf="[ptlGamingPanel1,ptlGamingPanel2,ptlGamingPanel3]?.includes(panel.panelType1)">
      <div class="ptl-gaming-video-panel video-wrapper"
        [ngClass]="{'ptl-gaming-panel1' : panel.panelType1 === ptlGamingPanel1,'ptl-gaming-panel2' : panel.panelType1 === ptlGamingPanel2,'ptl-gaming-panel3' : panel.panelType1 === ptlGamingPanel3}">
        <video [muted]="true" [poster]="panel.detailBGUrl" autoplay loop playsinline webkit-playsinline preload="metadata"
          controlsList="noplaybackrate noaudio nodownload nofullscreen">
          <source [src]="panel.videoUrl" type="video/mp4" />
        </video>
         <!-- blocks iOS interaction -->
        <div class="video-overlay"></div>
        <div class="ptl-gaming-video-panel-container"
          [ngClass]="{'ptl-gaming-panel1-container' : panel.panelType1 === ptlGamingPanel1, 'ptl-gaming-panel2-container' : panel.panelType1 === ptlGamingPanel2, 'ptl-gaming-panel3-container' : panel.panelType1 === ptlGamingPanel3, 'ptl-gaming-panel2-container-other-lang' : (panel.panelType1 === ptlGamingPanel2 && language !== 'en-us' )}">
          <span class="ptl-gaming-video-panel-title"
            [ngClass]="{'intelOne-headline': setFontIntelDisplayOne, 'ptl-gaming-panel1-title' : panel.panelType1 === ptlGamingPanel1, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language),'ptl-gaming-panel1-title-rtl' : (panel.panelType1 === ptlGamingPanel1 && rtlLangs.includes(language))}"
            [innerHTML]="panel?.tr_title"></span>
          <div [ngClass]="{'ptl-gaming-panel1-subtitle' : panel.panelType1 === ptlGamingPanel1}">
            <img *ngIf="panel.badgeUrl" [src]="panel.badgeUrl" alt="proc_badge">
            <p *ngIf="panel.tr_pretitle" [class.intelOne-display]="setFontIntelDisplayOne"
              [ngClass]="{'ptl-gaming-panel1-subtxt' : panel.panelType1 === ptlGamingPanel1, 'ptl-gaming-panel2-subtxt' : panel.panelType1 === ptlGamingPanel2,'ptl-gaming-panel3-subtxt' : panel.panelType1 === ptlGamingPanel3}"
              [innerHTML]="panel.tr_pretitle"></p>
          </div>
        </div>
      </div>
    </section>
    <section *ngIf="panel.panelType1 === ptlGamingPanel4">
      <ngb-carousel #carousel class="ptl-gaming-custom-carousel" [interval]="0" [wrap]="true" [showNavigationArrows]="false"
        [pauseOnHover]="false" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event, carousel)">
        <ng-template ngbSlide *ngFor="let item of panel.badgeIcons; let i = index">
          <div class="ptl-gaming-panel4" style="background-image: url({{item.imgUrl}});">
            <div class="carousel-panel-whole-container"
              [ngClass]="{'carousel-panel-container':(i === 0 || i === 2), 'carousel-mid-panel-container':i === 1, 'rtlLang-carousel-mid-panel-container':(i === 1 && rtlLangs.includes(language))}">
              <p class="ptl-gaming-video-panel-title" [ngClass]="{'intelOne-headline': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language),'carousel-title-last-panel': i === 2, 'carousel-title-first-panel': i === 0, 'carousel-title-mid-panel': i === 1}"
                [innerHTML]="item.tr_badgeTitle"></p>
              <p class="ptl-gaming-carousel-subtitle" [class.intelOne-display]="setFontIntelDisplayOne"
                [ngClass]="{'carousel-subtitle-first-last-panel':(i === 0 || i === 2), 'carousel-subtitle-mid-panel': i === 1}"
                [innerHTML]="item.tr_badgeSubTitle"></p>
            </div>
            <div class="caurosel-panel-bottom-container">
              <p class="ptl-gaming-video-panel-title" [ngClass]="{'intelOne-headline': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}"
                [innerHTML]="item.tr_badgeSubTitle1"></p>
              <p class="ptl-gaming-carousel-subtitle-bottom" [class.intelOne-display]="setFontIntelDisplayOne"
                [innerHTML]="item.tr_badgeSubTitle2"></p>
            </div>
          </div>
        </ng-template>
      </ngb-carousel>
    </section>
    <section *ngIf="panel.panelType1 === ptlGamingPanel5" class="ptl-gaming-panel5">
      <span class="legal-text-decoration" [class.intelOne-display]="setFontIntelDisplayOne"
        (click)="openPTLGamingLegalModal(modalContent)" [innerHTML]="panel.tr_title">
      </span>
    </section>
     <!-- PTL Gaming Processor DDP end -->

  </ng-container>
</div>
<!--Processor DDp for WCL -->
<div *ngIf="isWildcatLake">
  <ng-container>
    <div class="mobile-wrapper">
      <div class="content" [style.background-image]="'url(' + wclBgImgUrl + ')'">
        <section id="wclProcessPanelOne">
          <div class="badge_align">       
            <div class="image-container">
              <img [src]="wclBgClrImgUrl" alt="badge background" class="badge-bg" />          
              <div class="overlay-content">
                <img [src]="panelData[0]?.badgeUrl" alt="Intel logo" class="intel-logo" />
              </div>
            </div>       
          </div>
          <div class="everyday-logo">
            <img [src]="panelData[0]?.everytileBG" alt="everyday logo" class="everyday-logo" />
          </div>
        </section>
        <section id="wclProcessPanelTwo">
          <div class="laptop-wrapper">
             <div class="wcl-badge wcl-badge-green-pill">
              <img [src]="panelData[1]?.panel2_imgUrl" class="wcl-panel-laptop" alt="battery" />
            </div>
            <div class="screen-overlay" [ngClass]="{'intelOne-Text': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}">            
              <div class="chip top">
                <div class="wcl-badge-bgcrips" [ngClass]="longLangWclChips.includes(language) ? 'wcl-chip-longLang-alignment' : ''">
                  <img [src]="panelData[1]?.panel2_imgUrl1" class="wcl-panel2-icon" alt="crips_icon" />
                  <span class="wcl-badge-crips wcl-badge-cyan-pill" [innerHtml]="panelData[1]?.panel2_trtitle1"></span>
                </div>
              </div>            
              <div class="chip left">
                <div class="wcl-badge-fast wcl-badge-fast-pills" [ngClass]="language !== 'en-us' ? 'wcl-chip-longLang-alignment' : ''" [innerHtml]="panelData[1]?.panel2_trtitle0"></div>            
             </div>            
              <div class="chip right">
                <div class="wcl-badge-binder wcl-badge-binge-pills" [ngClass]="language !== 'en-us' ? 'wcl-chip-longLang-alignment' : ''" [innerHtml]="panelData[1]?.panel2_trtitle3"></div>
              </div>
              <div class="chip chip-leftbottom">
                <img [src]="panelData[1]?.panel2_imgUrl2" class="wcl-adobe-laptop" alt="abode_icon" />
              </div>            
            </div>
          </div>
          <div class="wcl-panel-wrapper">
            <div class="">
              <h2 class="wcl-panel2-title" [ngClass]="{'intelOne-Text': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}" [innerHTML]="panelData[1]?.panel2_trtitle"></h2>
              <p class="wcl-panel2-subtitle" [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="panelData[1]?.panel2_trsubtitle"></p>
            </div>
          </div>
        </section>
        <section id="wclProcessPanelThree">
          <div class="">            
            <div class="laptop-wrapper">
              <div class="wcl-badge wcl-badge-green-pill">
                <div class="wcl-badge wcl-badge-green-pill">
                  <img [src]="panelData[2]?.panel3_imgUrl" class="wcl-panel-laptop3" alt="battery" />
                </div>
              </div>
              <div class="screen-overlay" [ngClass]="{'intelOne-Text': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}">            
                <div class="chip chip3-top">
                  <div class="wcl-battery-unplugged">
                    <img [src]="panelData[2]?.panel3_imgUrl1" class="wcl-panel3-unplugged" alt="unplugged" />
                    <span class="wcl-badge-unplugged wcl-badge-unplugged-pills" [innerHtml]="panelData[2]?.panel3_tr_title0"></span>
                  </div>
                </div>                       
                <div class="chip chip3-right">
                  <div class="wcl-badge3-trtitle1 wcl-badge-title1-pills" [ngClass]="language !== 'en-us' ? 'wcl-chip-longLang-alignment' : ''" [innerHtml]="panelData[2]?.panel3_tr_title1"></div>
                </div>
                <div class="chip chip3-bottom">
                  <div class="wcl-badge3-trtitle2 wcl-badge-title2-pills" [ngClass]="language !== 'en-us' ? 'wcl-chip-longLang-alignment' : ''" [innerHtml]="panelData[2]?.panel3_tr_title2"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="wcl-panel-wrapper">
            <div class="">
              <h2 class="wcl-panel3-trtitle" [ngClass]="{'intelOne-Text': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}" [innerHTML]="panelData[2]?.panel3_tr_title"></h2>
              <p class="wcl-panelthree-subtitle" [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="panelData[2]?.panel3_tr_subtitle"></p>
            </div>
          </div>
        </section>
        <section id="wclProcessPanelFour">
          <div class="">         
             <div class="laptop-wrapper">
              <div class="wcl-badge wcl-badge-green-pill">
                <img [src]="panelData[3]?.panel4_imgUrl" class="wcl-panel-laptop4" alt="battery" />
              </div>
            <div class="screen-overlay" [ngClass]="{'intelOne-Text': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}">            
              <div class="chip chip4-top">
                <div class="wcl-badge4 wcl-badge-trtitle-pill4" [ngClass]="language !== 'en-us' ? 'wcl-chip-longLang-alignment' : ''" [innerHtml]="panelData[3]?.panel4_tr_title0"></div>
              </div>            
              <div class="chip chiptop-right">
               <img [src]="panelData[3]?.panel4_imgUrl1" class="wcl-panel4-img" alt="invest icon" />            
              </div>            
              <div class="chip chipbottom-right">
                 <img [src]="panelData[3]?.panel4_imgUrl2" class="wcl-windows4-icon" alt="windows_icon" />
              </div>
              <div class="chip chip-leftbottom" [ngClass]="language === 'sk' ? 'chip-leftbottom-otherLang' : ''">
                <div class="wcl-ai-sparkle" [ngClass]="language !== 'en-us' ? 'wcl-chip-longLang-alignment' : ''">
                  <img [src]="panelData[3]?.panel4_imgUrl3" class="wcl-sparkle4_icon" alt="sparkle_icon" />
                  <span class="wcl-badge4-sparkle wcl-badge-sparkle-pill" [innerHtml]="panelData[3]?.panel4_tr_title3"></span>
                </div>
              </div>            
            </div>
          </div>            
          </div>
          <div class="wcl-panel-wrapper">
            <div class="">
              <h2 class="wcl-panel3-trtitle" [ngClass]="{'intelOne-Text': setFontIntelDisplayOne, 'other-lang-font-style' : !setFontIntelDisplayOne, 'non-italic-lang-cls' : nonItalicLangArray.includes(language)}" [innerHTML]="panelData[3]?.panel4_tr_title"></h2>
              <p class="wcl-panel4-subtitle" [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="panelData[3]?.panel4_tr_subtitle"></p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </ng-container>
</div>
<!--Processor DDp for WCL End-->

<!-- PTL Gaming Processor DDP legal and disclamier pop-up start -->
<ng-template #modalContent let-modal>
  <div class="modal-header" [class.intelOne-display]="setFontIntelDisplayOne" [ngClass]="[!setFontIntelDisplayOne ? setFont() : '']">
    <span class="modal-title" [innerHTML]="panelData[4].tr_title"></span>
    <div class="close-icon-container" (click)="closePTLGamingLegalModal()">
      <img class="close-icon" src="assets/images/modal_close_icon.svg" alt="close_icon" />
    </div>
  </div>
  <div class="modal-body" [class.intelOne-display]="setFontIntelDisplayOne" [ngClass]="[!setFontIntelDisplayOne ? setFont() : '']">
    <p [innerHTML]="panelData[4].tr_subtitle"></p>
  </div>
</ng-template>
<!-- PTL Gaming Processor DDP legal and disclamier pop-up end -->
